import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import {Modal, notification} from 'ant-design-vue'
import { ACCESS_TOKEN, TENANT_ID } from "@/store/mutation-types"
import configService from '@/utils/service/config.service'
import i18n from '@/i18n'

/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jeecg-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
//let apiBaseUrl = window._CONFIG['domianURL'] || "/jeecg-boot";
let apiBaseUrl = configService.apiUrl;
//console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
  //baseURL: '/jeecg-boot',
  baseURL: apiBaseUrl, // api base_url
  // timeout: 60000 // 请求超时时间
  timeout: 180000 // 请求超时时间
})

// 存储所有请求的取消令牌
const pendingRequests = new Map();

// 生成请求的唯一标识
const generateRequestKey = (config) => {
  if (!config) return '';
  
  const { url, method } = config;
  // const params = config.params ? { ...config.params } : {};
  // // 移除时间戳参数
  // delete params._t;
  // return `${url}&${method}&${JSON.stringify(params)}`;
  return `${url}&${method}`;
};

// 添加请求到等待队列
const addPendingRequest = (config) => {
  if (!config) return;
  
  const requestKey = generateRequestKey(config);
  
  const url = '/sys/duplicate/check&get';// 校验重复
  if (pendingRequests.has(requestKey) && url != requestKey) {
    pendingRequests.get(requestKey).cancel('取消重复请求');
    pendingRequests.delete(requestKey);
  }
  
  const source = axios.CancelToken.source();
  config.cancelToken = source.token;
  pendingRequests.set(requestKey, source);
};

// 从等待队列移除请求
const removePendingRequest = (config) => {
  if (!config) return;
  
  const requestKey = generateRequestKey(config);
  if (requestKey && pendingRequests.has(requestKey)) {
    pendingRequests.delete(requestKey);
  }
};

const err = (error) => {
  if (error.response) {
    let that=this;
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    console.log("------异常响应------",token)
    console.log("------异常响应------",error.response.status)
    switch (error.response.status) {
      case 403:
        notification.error({ message: i18n.t('系统提示'), description: i18n.t('拒绝访问'),duration: 4})
        break
      case 500:
        let path = window.location.href
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        if(token && data.message.includes("Token失效") && path.indexOf('/user/login') < 0){
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          // store.dispatch('Logout').then(() => {
          //     window.location.reload()
          // })
          Modal.error({
            title: i18n.t('登录已过期'),
            content: i18n.t('很抱歉，登录已过期，请重新登录'),
            okText: i18n.t('重新登录'),
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                Vue.ls.remove(ACCESS_TOKEN)
                try {
                  if(path.indexOf('/user/login')==-1){
                    window.location.reload()
                  }
                }catch (e) {
                  window.location.reload()
                }
              })
            }
          })
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404:
          notification.error({ message: i18n.t('系统提示'), description: i18n.t('很抱歉，资源未找到!'),duration: 4})
        break
      case 504:
        notification.error({ message: i18n.t('系统提示'), description: i18n.t('网络超时')})
        break
      case 401:
        notification.error({ message: i18n.t('系统提示'), description: i18n.t('未授权，请重新登录'),duration: 4})
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
            //   window.location.reload()
            window.location.href = "/user";
            }, 1500)
          })
        }
        break
      default:
        notification.error({
          message: i18n.t('系统提示'),
          description: data.message,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  //update-begin-author:taoyan date:2020707 for:多租户
  let tenantid = Vue.ls.get(TENANT_ID)
  if (!tenantid) {
    tenantid = 0;
  }
  config.headers[ 'tenant_id' ] = tenantid
  //update-end-author:taoyan date:2020707 for:多租户
  // i18n：携带当前语言，后端按此返回对应语言的消息（后端未支持时忽略该头，行为不变）
  config.headers[ 'Accept-Language' ] = store.getters.language || 'zh-CN'
  if(config.method=='get'){
    if(config.url.indexOf("sys/dict/getDictItems")<0){
      config.params = {
        _t: Date.parse(new Date())/1000,
        ...config.params
      }
    }
  }
  // 添加到pending请求队列
  // addPendingRequest(config);
  return config
},(error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
    // 请求成功，从pending队列移除
    // removePendingRequest(response.config);
    return response.data
  }, (error) => {
    // 请求失败，从pending队列移除
    if (error.config) {
      // removePendingRequest(error.config);
    }
  }
)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}